import { render } from "./ZKJC.vue?vue&type=template&id=8d50266a&scoped=true"
import script from "./ZKJC.vue?vue&type=script&lang=js"
export * from "./ZKJC.vue?vue&type=script&lang=js"

import "./ZKJC.vue?vue&type=style&index=0&id=8d50266a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d50266a"]])

export default __exports__